import { Row as BootstrapRow } from "react-bootstrap";
import styled, { css } from "styled-components";
export const RowContentStyles = css(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    margin-bottom: ${theme.spacings.xs};
    border-radius: 6px;
    box-shadow: rgb(0 0 0 / 4%) 0 3px 5px;
  `
);
const Row = styled(BootstrapRow)`
  &.content {
    ${RowContentStyles}
  }
`;
export default Row;
